export const DIRECTION = {
    NORTH: 'NORTH',
    NORTH_EAST: 'NORTH_EAST',
    EAST: 'EAST',
    SOUTH_EAST: 'SOUTH_EAST',
    SOUTH: 'SOUTH',
    SOUTH_WEST: 'SOUTH_WEST',
    WEST: 'WEST',
    NORTH_WEST: 'NORTH_WEST',
};
